import {PageDef, PagesGroupDef} from "@/library/types/pages"

export const PAGE_GROUP_LICENCES = "PAGE_GROUP_LICENCES"
export const PAGE_GROUP_STATISTICS = "PAGE_GROUP_STATISTICS"
export const PAGE_GROUP_RESOURCES = "PAGE_GROUP_RESOURCES"
export const PAGE_GROUP_ADMIN = "PAGE_GROUP_ADMIN"

export const PAGE_INDEX = "PAGE_INDEX"
export const PAGE_NEWS = "PAGE_NEWS"
export const PAGE_LICENCES_LIST = "PAGE_LICENCES_LIST"
export const PAGE_LICENCES_CREATE = "PAGE_LICENCES_CREATE"
export const PAGE_STATISTICS_SALES = "PAGE_STATISTICS_SALES"
export const PAGE_STATISTICS_LOGINS = "PAGE_STATISTICS_LOGINS"
export const PAGE_RESOURCES_FAQ = "PAGE_RESOURCES_FAQ"
export const PAGE_RESOURCES_MANUALS = "PAGE_RESOURCES_MANUALS"
export const PAGE_RESOURCES_CHANGELOGS = "PAGE_RESOURCES_CHANGELOGS"
export const PAGE_RESOURCES_DOWNLOADS = "PAGE_RESOURCES_DOWNLOADS"
export const PAGE_RESOURCES_SUPPORT = "PAGE_RESOURCES_SUPPORT"
export const PAGE_ADMIN_MY_PROFILE = "PAGE_ADMIN_MY_PROFILE"
export const PAGE_ADMIN_EMPLOYEES = "PAGE_ADMIN_EMPLOYEES"
export const PAGE_LOGOUT = "PAGE_LOGOUT"

export const pageGroups: { [key: string]: PagesGroupDef } = {
    PAGE_GROUP_LICENCES: {
        name: "Lisensiering",
        description: "Administrering av lisenser",
        url: "/portal/licences",
        requiresRole: ["SystemAdmin"]
    },

    PAGE_GROUP_STATISTICS: {
        name: "Statistikk",
        description: "Få en oversikt over lisenser og salg",
        url: "/portal/statistics",
        requiresRole: ["SystemAdmin"]
    },

    PAGE_GROUP_RESOURCES: {
        name: "Resurser",
        description: "Informasjon, nedlastinger, og support",
        url: "/portal/resources"
    },

    PAGE_GROUP_ADMIN: {
        name: "Administrering",
        description: "Administrer dine medarbeidere og profil",
        url: "/portal/admin"
    }
}

export const pages: { [key: string]: PageDef } = {
    PAGE_INDEX: {
        navName: 'Velkommen',
        navLink: '/',
        isNavItem: false
    },
    PAGE_NEWS: {
        navName: "Nyheter",
        navLink: "/dashboard/news",
        isNavItem: false,
        description: "En oversikt over siste nyheter",
    },
    PAGE_LICENCES_LIST: {
        navName: "Lisenser",
        navIcon: <i className="fas fa-file-certificate"/>,
        navLink: "/list",
        navGroup: PAGE_GROUP_LICENCES,
    },
    PAGE_LICENCES_CREATE: {
        navName: "Ny lisens",
        navIcon: <i className="fas fa-hexagon-plus" style={{
            transform: "rotate(90deg)"
        }}/>,
        navLink: "/create",
        navGroup: PAGE_GROUP_LICENCES,
    },
    PAGE_STATISTICS_SALES: {
        navName: "Salgsstatistikk",
        navLink: "/sales",
        navGroup: PAGE_GROUP_STATISTICS,
        navIcon: <i className="fas fa-chart-simple"/>,
    },
    PAGE_STATISTICS_LOGINS: {
        navName: "Innlogginger",
        navLink: "/logins",
        navGroup: PAGE_GROUP_STATISTICS,
        navIcon: <i className="fas fa-user-magnifying-glass"/>,
    },
    PAGE_RESOURCES_FAQ: {
        navName: "FAQ",
        navLink: "/faq",
        navGroup: PAGE_GROUP_RESOURCES,
        navIcon: <i className="fas fa-question-circle"/>,
    },
    PAGE_RESOURCES_MANUALS: {
        navName: "Manualer",
        navLink: "/manuals",
        navGroup: PAGE_GROUP_RESOURCES,
        navIcon: <i className="fas fa-book"/>,
    },
    PAGE_RESOURCES_CHANGELOGS: {
        navName: "Programendringer",
        navLink: "/program-changes",
        navGroup: PAGE_GROUP_RESOURCES,
        navIcon: <i className="fas fa-clipboard-list"/>,
        description: "En oversikt over siste programendringer",
    },
    PAGE_RESOURCES_DOWNLOADS: {
        navName: "Nedlastinger",
        navLink: "/downloads",
        navGroup: PAGE_GROUP_RESOURCES,
        navIcon: <i className="fas fa-download"/>,
    },
    PAGE_RESOURCES_SUPPORT: {
        navName: "Support",
        navLink: "/support",
        navAppend: true,
        navGroup: PAGE_GROUP_RESOURCES,
        navIcon: <i className="fas fa-messages-question"/>,
    },
    PAGE_ADMIN_MY_PROFILE: {
        navName: "Min profil",
        navLink: "/my-profile",
        navGroup: PAGE_GROUP_ADMIN,
        navIcon: <i className="fas fa-user-pen"/>,
    },
    PAGE_ADMIN_EMPLOYEES: {
        navName: "Medarbeidere",
        navLink: "/employees",
        navGroup: PAGE_GROUP_ADMIN,
        navIcon: <i className="fas fa-users"/>,
        requiresRole: ["SystemAdmin"]
    },
    //PAGE_LOGOUT: {
    //    navName: "Logg ut",
    //    navLink: "/sign-out",
    //    navIcon: <i className="fas fa-sign-out"/>
    //}
}
